import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const ticket: string = sessionStorage.getItem('CDFEE2BC43D63CAEAA3B169AD31E966C');
        if (ticket) {
            request = request.clone({ headers: request.headers.set('Authorization', ticket) });
        }

        // DSA users act as a selected center; send it so the API can authorize
        // per work. External apps / backoffice carry their center in the token.
        const centerRaw: string = sessionStorage.getItem('50EE60E5468D8FC43984228303D24EE9');
        if (centerRaw) {
            try {
                const center = JSON.parse(centerRaw);
                if (center && center.guid) {
                    request = request.clone({ headers: request.headers.set('RequestCenter', center.guid) });
                }
            } catch (e) { /* ignore malformed center */ }
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) { }
                return event;
            }),
            catchError(error => {
                //  console.clear();
                console.log('Error:: dentbox : ' + error.statusText);
                if (error.status === 401) {
                    this.handleAuthError();
                    // return of(error);
                }
                throw error;
            }));
    }

    private handleAuthError() {
        sessionStorage.clear();
        this.router.navigate(['unauthorized']);
    }
}
